import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "redux/Notifications/reducer";

export const errorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      api.dispatch(
        enqueueSnackbar({
          message:
            "data" in action.error
              ? (action.error.data as { message: string }).message
              : action.error.message,
          options: { variant: "error" },
        })
      );
    }

    return next(action);
  };
